"use client"

import { useState } from "react"
import { ScanFace } from "lucide-react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import RegisteredFacesTab from "./RegisteredFacesTab"
import RegisterFaceTab from "./RegisterFaceTab"

export default function RegistrationFacesContent() {
  const [refreshSignal, setRefreshSignal] = useState(0)

  return (
    <div className="container mx-auto p-0 space-y-4">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-blue-50 rounded-lg">
          <ScanFace className="h-6 w-6 text-blue-600" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">Registration Faces</h1>
          <p className="text-sm text-gray-500">Manage teacher and staff face registrations for attendance</p>
        </div>
      </div>

      <Tabs defaultValue="registered" className="w-full">
        <TabsList>
          <TabsTrigger value="registered">Registered Faces</TabsTrigger>
          <TabsTrigger value="register">Register Face</TabsTrigger>
        </TabsList>
        <TabsContent value="registered">
          <RegisteredFacesTab refreshSignal={refreshSignal} />
        </TabsContent>
        <TabsContent value="register">
          <RegisterFaceTab onRegisterSuccess={() => setRefreshSignal((prev) => prev + 1)} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
